import React, { useState, useEffect } from 'react';
import './CircleDownloadButton.css';
import ico from "../../assets/icons8-download-file-50.png"
const CircleDownloadButton = () => {
  const [state, setState] = useState({ load: false, done: false });

  useEffect(() => {
    let timeout1, timeout2;
    if (state.load) {
      timeout1 = setTimeout(() => setState({ load: false, done: true }), 1000);
      timeout2 = setTimeout(() => setState({ load: false, done: false }), 5000);
    }
    return () => {
      clearTimeout(timeout1);
      clearTimeout(timeout2);
    };
  }, [state.load]);

  const handleClick = () => {
    if (!state.load && !state.done) {
      setState({ load: true, done: false });
    }
  };

  return (
    <div
      className={`btn-circle-download ${state.load ? 'load' : ''} ${state.done ? 'done' : ''}`}
      onClick={handleClick}
    >
      {/* <svg id="arrow" width="14px" height="20px" viewBox="17 14 14 20">
        <path d="M24,15 L24,32"></path>
        <polyline points="30 27 24 33 18 27"></polyline>
      </svg> */}
      {/* <svg id="arrow" fill="#000000" width="30px" height="30px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
  <path d="M20,6.52797748 L20,19.5 C20,20.8807119 18.8807119,22 17.5,22 L6.5,22 C5.11928813,22 4,20.8807119 4,19.5 L4,4.5 C4,3.11928813 5.11928813,2 6.5,2 L15.4720225,2 C15.6047688,1.99158053 15.7429463,2.03583949 15.8535534,2.14644661 L19.8535534,6.14644661 C19.9641605,6.25705373 20.0084195,6.39523125 20,6.52797748 Z M15,3 L6.5,3 C5.67157288,3 5,3.67157288 5,4.5 L5,19.5 C5,20.3284271 5.67157288,21 6.5,21 L17.5,21 C18.3284271,21 19,20.3284271 19,19.5 L19,7 L15.5,7 C15.2238576,7 15,6.77614237 15,6.5 L15,3 Z M16,3.70710678 L16,6 L18.2928932,6 L16,3.70710678 Z M12,16.2928932 L14.1464466,14.1464466 C14.3417088,13.9511845 14.6582912,13.9511845 14.8535534,14.1464466 C15.0488155,14.3417088 15.0488155,14.6582912 14.8535534,14.8535534 L11.9198269,17.7872799 C11.8307203,17.9246987 11.6759769,18.0156098 11.5,18.0156098 C11.3240231,18.0156098 11.1692797,17.9246987 11.0801731,17.7872799 L8.14644661,14.8535534 C7.95118446,14.6582912 7.95118446,14.3417088 8.14644661,14.1464466 C8.34170876,13.9511845 8.65829124,13.9511845 8.85355339,14.1464466 L11,16.2928932 L11,9.5 C11,9.22385763 11.2238576,9 11.5,9 C11.7761424,9 12,9.22385763 12,9.5 L12,16.2928932 L12,16.2928932 Z"/>
</svg> */}
<img src={ico} alt="download file" className=" size-7" id="arrow"/>
      <svg id="check" width="21px" height="15px" viewBox="13 17 21 15">
        <polyline points="32.5 18.5 20 31 14.5 25.5"></polyline>
      </svg>
      <svg id="border" width="48px" height="48px" viewBox="0 0 48 48">
        <path d="M24,1 L24,1 L24,1 C36.7025492,1 47,11.2974508 47,24 L47,24 L47,24 C47,36.7025492 36.7025492,47 24,47 L24,47 L24,47 C11.2974508,47 1,36.7025492 1,24 L1,24 L1,24 C1,11.2974508 11.2974508,1 24,1 L24,1 Z"></path>
      </svg>
    </div>
  );
};

export default CircleDownloadButton;
